<template>
    <form class="col-md-12 mb-0" @submit.prevent="onSave">
        <div v-if="model && model.items && model.items.length > 0">
            <div class="card border-primary"
                v-for="(item, index) in model.items"
                :key="index"
            >
                <h6 class="card-header text-primary">
                    <i class="fas fa-user-edit mr-2"></i>
                    {{ item.fullName}}
                </h6>


                <div class="card-body" id="admittedEditCard">
                    <div class="row">
                        <div class="form-group col-12 col-md-6 col-lg-3">
                            <vs-checkbox
                                v-model="item.confirmed"
                                @change="v => { if(item.confirmed === true)  { item.deniedConfirmation = null; item.deniedReason = null; } if(!item.confirmed)  { item.accommodationRequired = null; item.fromDate = null; item.toDate = null; item.accommodationPlaceId = null; item.confirmationNote = null; item.transportationRequired = null; item.vegetarianMenuRequired = null; item.accommodationTypeId = null; }}"
                            >{{$t('registers.events.evaluation.tempRanking.editor.confirmed')}}</vs-checkbox>
                        </div>
                        <div v-if="item.confirmed" class="form-group col-12 col-md-6 col-lg-9">
                            <label
                                class="font-weight-bold"
                                :for="'confirmationNote' + _uid"
                            >{{$t('participationConfirmation.note')}}</label>
                            <textarea
                                class="form-control"
                                rows="2"
                                v-model="item.confirmationNote"
                                :name="'confirmationNote' + _uid"
                                :id="'confirmationNote' + _uid"
                            ></textarea>
                        </div>
                        <div v-if="item.confirmed"
                            class="form-group col-12 col-md-6 col-lg-3"
                        >
                        </div>
                        <div v-if="item.confirmed"
                            class="form-group col-12 col-md-6 col-lg-4"
                        >
                            <vs-checkbox
                                v-model="item.transportationRequired">
                                {{ $t('participationConfirmation.transportationRequired') }}
                            </vs-checkbox>
                        </div>
                        <div v-if="item.confirmed"
                            class="form-group col-12 col-md-6 col-lg-3"
                        >
                            <vs-checkbox
                                v-model="item.vegetarianMenuRequired">
                                {{ $t('participationConfirmation.vegetarianMenuRequired') }}
                            </vs-checkbox>
                        </div>
                        <div v-if="item.confirmed"
                            class="form-group col-12 col-md-6 col-lg-3"
                        >
                            <vs-checkbox
                                v-model="item.accommodationRequired">
                                {{ $t('participationConfirmation.accommodationRequired') }}
                            </vs-checkbox>
                        </div>

                        <div class="form-group col-12 col-md-6 col-lg-9 mb-0" v-if="item.accommodationRequired === true">
                            <DateRange
                                :required="true"
                                :id="'requestDateRange' + _uid"
                                :startTime.sync="item.fromDate"
                                :endTime.sync="item.toDate"
                                :format="customDateFormat"
                                :showTime="false"
                                :startTitle="'participationConfirmation.fromDate'"
                                :endTitle="'participationConfirmation.toDate'"
                                :bindPopup="true"
                                :popupContainerId="'#admittedEditCard'"
                                start-description="participationConfirmation.fromDateDescription"
                                end-description="participationConfirmation.toDateDescription" >
                            </DateRange>
                        </div>

                        <div class="col-12 col-lg-8 form-group" v-if="item.accommodationRequired === true">
                            <label class="col-form-label font-weight-bold" :for="'accommodationPlace' + _uid">{{$t('participationConfirmation.accommodationPlace')}}</label>
                            <kendo-multicolumncombobox
                                :data-source="accommodationPlaceDataSource"
                                :data-text-field="'displayName'"
                                :data-value-field="'id'"
                                :name="'accommodationPlace' + _uid"
                                :id="'accommodationPlace' + _uid"
                                :clear-button="true"
                                :popup="popup"
                                v-model="item.accommodationPlaceId"
                                :placeholder="$t('choose')"
                                :no-data-template="$t('missingData')"
                                :filter="'contains'"
                                style="width:100%">
                                <kendo-multicolumncombobox-column :field="'name'"
                                                                :title="$t('registers.organizers.gridHeaders.name')">
                                </kendo-multicolumncombobox-column>
                                <kendo-multicolumncombobox-column :field="'address'"
                                                                :title="$t('address.cardTitle')">
                                </kendo-multicolumncombobox-column>
                            </kendo-multicolumncombobox>
                            <span class="text-danger" v-if="errors.has('accommodationPlace' + _uid)">{{ errors.first('accommodationPlace' + _uid) }}</span>
                        </div>

                        <div class="col-12 col-lg-4 form-group" v-if="item.accommodationRequired === true">
                            <label class="col-form-label font-weight-bold" :for="'roomType' + _uid">{{$t('participationConfirmation.accommodationType')}}</label>
                            <kendo-dropdownlist v-model="item.accommodationTypeId"
                                                :data-source="roomsSource"
                                                :data-text-field="isEnVersion ? 'textEn' : 'text'"
                                                :data-value-field="'value'"
                                                :clear-button="true"
                                                :popup="popup"
                                                :disabled="!item.accommodationPlaceId"
                                                :optionLabel="$t('choose')"
                                                :name="'roomType' + _uid"
                                                :id="'roomType' + _uid"
                                                style="width:100%">
                            </kendo-dropdownlist>
                        </div>
                    </div>
                    <div class="row">
                        <hr class="col-12" v-if="item.accommodationRequired === true"/>

                        <div class="form-group col-12 col-md-6 col-lg-3">
                            <vs-checkbox
                                v-model="item.deniedConfirmation"
                                @change="v => { if(item.deniedConfirmation === true) { item.confirmed = null; item.confirmationNote = null; item.accommodationRequired = null; item.fromDate = null; item.toDate = null; item.accommodationPlaceId = null; item.transportationRequired = null; item.vegetarianMenuRequired = null; item.accommodationTypeId = null; } if(!item.deniedConfirmation === true) { item.deniedConfirmation = null; } }"
                            >{{$t('registers.events.evaluation.tempRanking.editor.deniedConfirmation')}}</vs-checkbox>
                        </div>

                        <div v-if="item.deniedConfirmation" class="form-group form-group col-12 col-md-6 col-lg-9">
                            <label
                                class="font-weight-bold"
                                :for="'deniedConfirmation' + _uid"
                            >{{$t('registers.events.evaluation.tempRanking.editor.deniedReason')}}</label>
                            <textarea
                                class="form-control"
                                rows="2"
                                v-model="item.deniedReason"
                                :name="'deniedConfirmation' + _uid"
                                :id="'deniedConfirmation' + _uid"
                            ></textarea>
                        </div>


                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <vs-checkbox
                                v-model="item.moveToRejected"
                                @change="v => { if(item.moveToRejected === true) item.moveToReserve = null }"
                            >{{$t('registers.events.evaluation.tempRanking.editor.moveToRejected')}}</vs-checkbox>
                        </div>

                        <div class="form-group col-12">
                            <vs-checkbox
                                v-model="item.moveToReserve"
                                @change="v => { if(item.moveToReserve === true) item.moveToRejected = null }"
                            >{{$t('registers.events.evaluation.tempRanking.editor.moveToReserve')}}</vs-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-right mt-1">
            <div class="btn-group" role="group" aria-label="Person edit buttons">
                <button type="button" class="btn btn-success" :disabled="saving" @click.stop="onSave">
                    <i v-if="saving" class="fas fa-spinner fa-spin"></i>
                    <i v-else class="fas fa-save"></i>
                    {{$t('buttons.save.btnText')}}
                </button>
                <button type="button" class="btn btn-danger" :disabled="saving" @click.stop="onCancel">
                    <i class="fas fa-ban"></i>
                    {{$t('buttons.cancel')}}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import DateRange from '@/components/dateTimeRange/DateTimeRange_new';
    import tempRanking from "@/services/tempRanking.service";
    import accommodationPlace from "@/services/accommodationPlace.service";
    import { AdmittedMultipleUpdateModel } from '@/models/models';
    import { Culture } from '@/models/enums';
    import { mapGetters } from 'vuex'

    export default {
        inject: ["$validator"],
        props: {
            value: {
                type: AdmittedMultipleUpdateModel,
                required: false,
            }
        },
        components: {
            DateRange
        },
        data() {
            return {
                model: this.value,
                saving: false,
                accommodationPlaceDataSource: null,
                roomsSource: [
                    { text: "Единична", textEn: "Single", value: 1 },
                    { text: "Двойна", textEn: "Double", value: 2 },
                    { text: "Тройна", textEn: "Triple", value: 3 },
                    { text: "Апартамент", textEn: "Apartment", value: 4 }
                ],
                schemaModels: {
                    accommodationPlaceSchemaModel: {
                        id: {
                            name: 'id',
                            type: 'number',
                            editable: false,
                            nullable: false,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.id'
                        },
                        name: {
                            name: 'name',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.name'
                        },
                        displayName: {
                            name: 'displayName',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.name'
                        },
                        address: {
                            name: 'address',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'address.cardTitle'
                        },
                        contactName: {
                            name: 'contactName',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.contactName'
                        },
                        phone: {
                            name: 'phone',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'registers.organizers.gridHeaders.phone'
                        },
                        mobilePhone: {
                            name: 'mobilePhone',
                            type: 'string',
                            editable: false,
                            nullable: true,
                            visible: true,
                            titleKey: 'person.mobilePhone'
                        }
                    }
                },
                popup: {
                    appendTo: $("#admittedEditCard")
                }
            };
        },
        computed: {
            ...mapGetters(['dateFormat']),
            fullNames() {
                return this.model.participantNames;
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            customDateFormat() {
                return `{0:${this.dateFormat}}`
            },
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new AdmittedMultipleUpdateModel(this.value);
                    this.loadAccommodationPlace();
                }
            },
        },
        methods: {
            loadAccommodationPlace() {
                if (!this.model || !this.model.registerEntityId) {
                    return;
                }

                accommodationPlace
                    .getForEvent(this.model.registerEntityId)
                    .then((response) => {
                        if (response.data) {
                            this.accommodationPlaceDataSource = response.data;
                        }
                    });
            },
            onSave() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.updateMultiple();
                    }
                });
            },
            updateMultiple() {
                this.saving = true;

                tempRanking
                    .updateMultiple(this.model)
                    .then((response) => {
                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                    this.$helpers.responseStatusCode(response)
                            ),
                            text: this.$helpers.responseMessage(response),
                            color: "success",
                            time: this.$store.getters.notificationDuration,
                        });

                        this.$emit("save", this.model);
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                    this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    })
                    .then(() => { this.saving = false; });
            },
            onCancel(e) {
                this.$emit("cancel", e);
            }
        }
    };
</script>

<style scoped>
    .con-vs-checkbox {
        justify-content:left;
    }
</style>
